module.exports = "<th>Отделка</th>\n<td>\n  <div class=\"filter__button-group\">\n    <term\n      ng-repeat=\"item in ::terms.has_decoration\"\n      source=\"source.has_decoration\"\n      behavior=\"radio\"\n      text=\"{$ ::item.text $}\"\n      ng-value=\"::item.value\"/>\n  </div>\n</td>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/advanced-browser/templates/sections/decoration.html
// module id = 340
// module chunks = 0